import React, { lazy, Suspense } from 'react';
import { graphql } from 'gatsby';
import Intro from 'features/white-papers/Intro';
import ContentWrapper from 'components/UI/ContentWrapper';
import ProjectConcept from 'features/project-cases/ProjectConcept';
import CallToAction from 'features/common/CallToAction';
import AdvisoryBoardSlider from 'features/common/AdvisoryBoardSlider';
import RelatedArticles from 'features/common/RelatedArticles';
import ContactUs from 'features/common/ContactUs';
import SEO from 'components/SEO';
import { DOMAIN_URL } from 'define';
import { modal as modalStore } from 'store';

import data from './data.json';

const WhitePaperFormModal = lazy(() => import('components/Modals/WhitePaperFormModal'));

export default function DataGovernanceForFinance({
  data: {
    introImagesJson: hero,
    allContentfulArticlePreview: { nodes: articles },
  },
}) {
  const whitepaperLink = `${DOMAIN_URL}${data.whitepaperLink}`;

  const openWhitePaperModal = () => {
    modalStore.open('white-paper');
  };

  return (
    <>
      <Intro {...data.intro} onButtonClick={openWhitePaperModal} gatsbyImage={hero} />
      <ContentWrapper paddingDisable="top">
        <ProjectConcept {...data.concept} setActive={() => {}} withTabs={false} theme="default" />
        <CallToAction {...data.cta} onButtonClick={openWhitePaperModal} />
        <AdvisoryBoardSlider {...data.advisoryBoard} />
        <RelatedArticles {...data.relatedArticles} items={articles} />
        <ContactUs {...data.getConsultation} />
      </ContentWrapper>
      <Suspense fallback={null}>
        <WhitePaperFormModal whitepaperName={data.intro.title} whitepaperLink={whitepaperLink} />
      </Suspense>
    </>
  );
}

export const Head = ({ location }) => <SEO {...data.head} {...location} />;

export const query = graphql`
  query ($pagePath: String, $lang: String) {
    introImagesJson(page: { eq: $pagePath }) {
      ...IntroImages
    }
    allContentfulArticlePreview(
      filter: {
        node_locale: { eq: $lang }
        pagesToDisplayOn: { elemMatch: { content: { eq: $pagePath } } }
      }
      sort: { publishDate: DESC }
    ) {
      nodes {
        ...ArticlePreview
      }
    }
  }
`;
